import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { apiPost } from '../brainApi';

const useStyles = makeStyles((theme) => ({
  buttonRounded: {
    border: '1px solid #808080',
    borderRadius: '25px',
    minWidth: '100px',
    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto',
    },
    padding: '5px 10px',
    marginBottom: '5px',
  },
}));

const StripeCustomersToSquare = () => {
  const classes = useStyles();
  const [message, setMessage] = useState('');
  const [showSubmitButton, setShowSubmitButton] = useState(true);

  const buttonHandler = () => {
    setShowSubmitButton(false);
    setMessage('Processing. Please wait...');
    // After 45 seconds, direct the user to CS to confirm completion. Process will timeout on the front-end after 60 seconds.
    // Slack message will be sent to pilot-notifications when this process is complete
    const timeoutId = setTimeout(() => {
      setMessage(
        'Square upload is taking a while. Please reach out to customer success to confirm the process is complete.',
      );
    }, 45000);
    return apiPost('/copy-stripe-customers-to-square')
      .then((r) => {
        setMessage(r);
        if (r.toLowerCase().includes('error')) setShowSubmitButton(true);
        return r;
      })
      .catch((e) => {
        setMessage(`There was an error. Please try again. Error details: ${e}`);
        setShowSubmitButton(true);
      })
      .finally(() => clearTimeout(timeoutId));
  };

  return (
    <div>
      <br />
      <Typography variant="h6">{message}</Typography>
      {showSubmitButton && (
        <Button onClick={buttonHandler} className={classes.buttonRounded}>
          Copy Stripe Customers to Square
        </Button>
      )}
    </div>
  );
};

export default StripeCustomersToSquare;
